import { generateMemberUrl, generateMallUrl } from '@/api/modules/openWeapp';
/**错误类型 */
export const ERROR_TYPR: { [key: string]: any } = {
  noPc: {
    title: '暂不支持PC端打开',
    icon: require('@/images/common/icon_noopen.png'),
  },
  noSupport: {
    title: '该小程序暂不支持打开',
    icon: require('@/images/common/icon_noopen.png'),
  },
  error: {
    title: '链接找不到了',
    icon: require('@/images/common/icon_404.png'),
  },
};

/**不同小程序配置 */
export const WX_CHAT: { [key: string]: string } = {
  1: 'gh_490af83aaafb', //会员
  2: 'gh_658ce0087331', //商城
};

/**不同小程序配置 */
export const URL_LINK_API: { [key: string]: any } = {
  1: generateMemberUrl, //会员
  2: generateMallUrl, //商城
};
